import _ from 'underscore';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import {Card} from 'material-ui/Card';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import {RadioButtonGroup, RadioButton} from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TimePicker from 'material-ui/TimePicker';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

import api from '../../api/api';
import DataStore from '../../api/DataStore';
import DropZone from '../common/DropZone.js';
import Validator from '../common/Validator.js';

import close_button_img from "../../img/btn-cancel.svg";
import remove_btn from '../../img/btn-remove-photo.svg';
import radioOffIcon from '../../img/ic-radio-off.svg';
import checkOffIcon from '../../img/ic-check-off.svg';

import './AdminLocationDetails.css';

const helpText = {
    description: "Describe the infusion center to potential patients and users of the locator. This will be publically displayed in the lo" +
    "cator listing. Please do not put any contact information in this area to limit spam.",
    email: "Locator users won't be able to contact the location through the locator tool contact form unless a location email addres" +
    "s is provided.",
    facilityType: 'If your location is owned by a hospital or located directly on the campus of a hospital then we consider the location "H' +
    'ospital Based"',
    fbHelp1: 'www.facebook.com/Facebook ID',
    fbHelp2: 'If you are logged into Facebook in your current browser, you should be able to click this link, and it will redirect you' +
    ' to your profile page. Then, copy the URL from your browsers address bar and come back here to paste.',
    closed: 'Please tell us why this location is temporarily closed and when it might re-open.'
}

const daysOfTheWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
]

const states = [
    "AL",
    "AK",
    "AS",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FM",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MH",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PW",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VI",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
    "SX",
    "SJ",
    "ST"
];

class AdminLocationDetails extends Component {

    constructor(props) {
        super(props);

        let location = props.location;
        let user = new DataStore().getUser();
        if (!location.key) {
            location = {
                businessHours: {},
                attributes: {},
                photos: [],
                orgId: user.orgId,
                isPreferred: user.isPreferred,
                addedBy: {
                    displayName: user.displayName,
                    userEmail: user.email
                },
                created: new Date().toString()
            }
        }

        this.state = {
            loading: true,
            attributes: null,
            edits: _.clone(location),
            originalPhotos: props.location.photos ? [...props.location.photos] : [],
            showDialog: false,
            errors: {},
            showErrorBanner: false,
            attributeComponents: null,
        }

    }

    componentWillMount() {
        api.getAttributes((attributes) => {
            // console.log(attributes);
            this.setState({
                attributes: attributes,
                attributeComponents: this.buildAttributeComponents(attributes),
                loading: false
            });
        });
    }

    hasAddedPhotos() {
        var result = false;
        if (this.state.edits.photos) {
            if (this.state.originalPhotos) {
                this.state.edits.photos.some((photo) => {
                    if (!this.state.originalPhotos.includes(photo)) {
                        result = true;
                        return true;
                    }
                    return false;
                });
            } else {
                result = true;
            }
        }
        return result;
    }

    onChange = (key, filter, event, value) => {
        if (filter == null || filter(value)) {
            this.setState((prevState) => {
                var edits = prevState.edits;
                edits[key] = value;
                return {edits: edits}
            });
        }
    }

    onBusinessHoursChange(update) {
        this.setState(prevState => {
            var edits = prevState.edits;
            _.extend(edits.businessHours, update)
            return {edits: edits}
        })
    }

    handleStateChange = (event, index, value) => {
        this.setState((state, props) => {
            let edits = state.edits;
            edits.stateAbbr = value;
            return {edits: edits};
        });
    }

    buildTextField(key, floatingLabelText, description, multiLine, filter) {
        return (
            <div style={{
                textAlign: "left"
            }}>
                <div>
                    <TextField
                        id={key}
                        name={key}
                        errorText={this.state.errors[key]}
                        errorStyle={{fontStyle: "italic"}}
                        floatingLabelText={floatingLabelText}
                        fullWidth={true}
                        onChange={this.onChange.bind(null, key, filter)}
                        value={ this.state.edits[key] ?
                            (this.state.edits[key] + "")
                            :
                            ""
                        }
                        multiLine={multiLine}
                        inputStyle={{color: "#18496c", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                        textareaStyle={{color: "#18496c", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                        underlineStyle={{borderWidth: "1px", borderColor: "#dddddd"}}/>
                </div>
                {description && description.length > 0 ?
                    <div className="location-edit-help-text">
                        {description}
                    </div>
                    :
                    null
                }
            </div>
        )
    }

    buildStateSelect() {
        return (
            <SelectField
                menuStyle={{zIndex:6000}}
                errorText={this.state.errors.stateAbbr}
                errorStyle={{fontStyle: "italic"}}
                floatingLabelText="State"
                labelStyle={{
                    fontFamily: "Lato",
                    color: "#1c5c7f",
                    fontSize: "18px",
                    fontWeight: 200
                }}
                value={this.state.edits.stateAbbr}
                onChange={this.handleStateChange}>
                {states.map((item, index) => {
                    return (<MenuItem value={item} primaryText={item} key={"state-" + index}/>)
                })}
            </SelectField>
        )
    }

    onAttributeOptionCheck = (attribute, optionKey) => {
        // console.log("check change %o %s", attribute, optionKey);
        this.setState((state, props) => {
            let edits = state.edits;

            let locationAttribute = edits.attributes[attribute.key];

            if (!locationAttribute) {
                locationAttribute = edits.attributes[attribute.key] = {
                    choice: [],
                    name: attribute.name
                };
            } else if (!locationAttribute.choice) {
                locationAttribute.choice = [];
            }

            let index = locationAttribute.choice.indexOf(optionKey);
            if (index === -1) {
                locationAttribute.choice.push(optionKey);
            } else {
                locationAttribute.choice.splice(index, 1);
            }

            return {
                edits: edits,
                attributeComponents: this.buildAttributeComponents(state.attributes)
            };
        });
    }

    onAttributeOptionChange = (attribute, event, value) => {
        // console.log("option change %o %s", attribute, value);
        this.setState((state, props) => {
            let edits = state.edits;

            let locationAttribute = edits.attributes[attribute.name];

            if (!locationAttribute) {
                locationAttribute = edits.attributes[attribute.key] = {
                    choice: [value],
                    name: attribute.name
                };
            } else {
                locationAttribute.choice[0] = value;
            }

            // console.log(edits.attributes);
            return {
                edits: edits,
                attributeComponents: this.buildAttributeComponents(state.attributes)
            };
        });
    }

    buildAttributeOptions(attribute) {
        if (attribute.options) {
            if (attribute.type === "many") {
                return this.buildCheckboxOptions(attribute);
            }
            return this.buildRadioButtonOptions(attribute);
        } else if (attribute.groups) {
            return (
                <div>
                    {Object.keys(attribute.groups).map((key, index) => {
                        attribute.groups[key].key = key;
                        return (
                            <div key={"attribute-group-" + index} style={{marginBottom: "25px"}}>
                                <div className="location-edit-section-subheader">
                                    {attribute.groups[key].name}
                                </div>
                                <div className="location-edit-attribute-options-container">
                                    {this.buildAttributeOptions(attribute.groups[key])}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        }
        return null;
    }

    isAttributeChecked(attribute, optionKey) {
        return this.state.edits.attributes &&
            this.state.edits.attributes[attribute.key] != null &&
            this.state.edits.attributes[attribute.key].choice != null &&
            this.state.edits.attributes[attribute.key].choice.includes(optionKey);
    }

    buildCheckboxOptions(attribute) {
        return (
            Object.keys(attribute.options).map((optionKey, index) => {
                return (
                    <div className="location-edit-attribute-option" key={"checkbox-" + optionKey + "-" + index}>
                        <Checkbox
                            label={attribute.options[optionKey].name}
                            labelStyle={{color: "#1c5c7f", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                            uncheckedIcon={<img src={checkOffIcon} alt="check off" />}
                            onCheck={this.onAttributeOptionCheck.bind(null, attribute, optionKey)}
                            checked={this.isAttributeChecked(attribute, optionKey)}/>
                    </div>
                )
            })
        )
    }

    buildRadioButtonOptions(attribute) {
        return (
            <RadioButtonGroup
                style={{display: "flex", flexWrap: "wrap", flex: 1}}
                defaultSelected={attribute.options[0]}
                name={attribute.name}
                valueSelected={this.state.edits.attributes != null && this.state.edits.attributes[attribute.key] != null
                    ? this.state.edits.attributes[attribute.key].choice[0]
                    : null}
                onChange={this.onAttributeOptionChange.bind(null, attribute)}>
                {Object.keys(attribute.options).map((optionKey, index) => {
                    return (
                        <RadioButton
                            style={{width: "50%"}}
                            labelStyle={{color: "#1c5c7f", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                            label={attribute.options[optionKey].name}
                            value={optionKey}
                            uncheckedIcon={<img src={radioOffIcon} alt="radio off" />}
                            key={"radio-" + optionKey + "-" + index}/>
                    )
                })}
            </RadioButtonGroup>
        )
    }

    buildAttributeComponents(attributes) {
        return attributes.map((attribute, index) => {
            return (
                <div key={"attribute-" + index}>
                    <div className="location-edit-section-header">
                        {attribute.name}
                    </div>
                    <div className="location-edit-attribute-options-container">
                        {this.buildAttributeOptions(attribute)}
                    </div>
                    {attribute.description ?
                        <div className="location-edit-attribute-description">
                            {attribute.description}
                        </div>
                        :
                        null
                    }
                    {this.state.errors[attribute.key] ?
                        <div className="location-edit-attribute-error">
                            {this.state.errors[attribute.key]}
                        </div>
                        :
                        null
                    }
                </div>
            )
        });
    }

    onUpdateBusinessHours = (businessHours) => {
        this.setState((state) => {
            let edits = state.edits;
            edits.businessHours = businessHours;
            return {edits: edits}
        })
    }

    onSaveClick = () => {
        if (this.validateLocation()) {
            if (this.state.originalPhotos) {
                this.state.originalPhotos.forEach((url, index) => {
                    if (!this.state.edits.photos || !this.state.edits.photos.includes(url)) {
                        api.deleteFile(url);
                    }
                });
            }

            // KBM - TODO: show spinner while geocoding
            if (this.state.edits.address1 !== this.props.location.address1) {
                console.log("We should be geocoding...");
                api.geoCodeQuery(this.state.edits.address1 + " " + this.state.edits.city + ", " + this.state.edits.stateAbbr + " " + this.state.edits.postCode, (lat, lng) => {
                    let edits = this.state.edits;
                    edits.latitude = lat;
                    edits.longitude = lng;

                    api.saveLocation(edits);
                    // let key = api.saveLocation(edits);
                    // if (key) {
                    //     edits.key = key;
                    // }

                    // api.updateLocationsLocationDawg(edits);
                    this.props.onClearSelection();
                })
            } else {
                api.saveLocation(this.state.edits);
                this.props.onClearSelection();
            }
        }
    }

    validateLocation() {
        let valid = true;
        let errors = {};
        let validator = new Validator();
        let validators = [
            {
                validate: validator.validateNonNull,
                keys: ["name", "address1", "city", "stateAbbr", "postCode", "phoneNumber", "numberOfChairs"],
                message: "Please enter a value"
            },
            {
                validate: validator.validateEmail,
                keys: ["emailAddress"],
                message: "Please enter a valid email address"
            },
            {
                validate: validator.validateUrl,
                keys: ["URL"],
                message: "Please enter a valid Website"
            },
        ]

        validators.forEach((fieldValidator, index) => {
            fieldValidator.keys.forEach((key, keyIndex) => {
                if (!fieldValidator.validate(this.state.edits[key])) {
                    errors[key] = fieldValidator.message;
                    valid = false;
                }
            })
        });

        this.state.attributes.forEach((attribute) => {
            if (attribute.required && !this.state.edits.attributes[attribute.key]) {
                errors[attribute.key] = "Please choose an option";
                valid = false;
            }
        });

        this.setState({errors: errors, showErrorBanner: !valid});

        return valid;
    }

    onCancelClick = () => {
        var hasAddedPhotos = this.hasAddedPhotos();
        // console.log("has added photos: " + hasAddedPhotos);
        if (!hasAddedPhotos) {
            this.props.onClearSelection();
        } else {
            this.setState({showDialog: true});
        }
    }

    onImageUploaded = (downloadURL) => {
        this.setState((state) => {
            let edits = {...state.edits};
            if (!edits.photos) {
                edits.photos = [downloadURL];
            } else {
                edits.photos.push(downloadURL);
            }
            return {edits: edits};
        });
    }

    onGoogleStreetViewImageUploaded = (downloadURL) => {
        this.setState((state) => {
            state.edits.google_street_view_image = downloadURL;
            return state;
        })
    }

    onDeleteClick = (photo, index) => {
        // console.log("onDeleteClick");
        this.setState((state) => {
            var index = state.edits.photos.indexOf(photo);
            // console.log("removing " + index);
            state.edits.photos.splice(index, 1);
            return state;
        })
    }

    onGoogleStreetViewDeleteClick = () => {
        this.setState((state) => {
            state.edits.google_street_view_image = null;
            return state;
        })
    }

    closeDialog = () => {
        this.setState({showDialog: false});
    }

    cleanupPhotos = () => {
        this.closeDialog();
        this.state.edits.photos.forEach((photo, indes) => {
            if (!this.state.originalPhotos || !this.state.originalPhotos.includes(photo)) {
                api.deleteFile(photo);
            }
        });
        this.props.onClearSelection();
    }

    onImageSortEnd = (info, event) => {
        this.setState((state) => {
            let edits = state.edits;
            edits.photos = arrayMove(edits.photos, info.oldIndex, info.newIndex);
            return {edits: edits};
        });
    }

    hideErrorBanner = () => {
        this.setState({showErrorBanner: false});
    }

    toggleTemporarilyClosed = () => {
        this.setState((prevState) => {
            let edits = prevState.edits;
            edits['temporarily_closed'] = !edits['temporarily_closed'];
            return {edits: edits};
        });
    }

    render() {
        return (
            <div className="location-edit-container" style={{height: "100%", overflow: "hidden"}}>
                <div className="location-edit-header">
                    <IconButton className="location-edit-close-button">
                        <img src={close_button_img} onClick={this.onCancelClick} alt="close button" />
                    </IconButton>
                </div>
                <div style={{textAlign: "center", width: "100%", height: "100%", overflow: "scroll"}}>
                    <div style={{display: "flex", flexDirection: "column", width: "100%", alignItems: "center"}}>
                        <div className="location-edit-page-title">
                            <div>
                                Add/Edit Location
                            </div>
                            <div className="location-edit-header-save-container">
                                {this.state.loading ?
                                    null
                                    :
                                    <FlatButton
                                        label="Save"
                                        labelStyle={{color: "#ffffff"}}
                                        backgroundColor="#53c9e8"
                                        onClick={this.onSaveClick} />
                                }
                            </div>
                        </div>
                        {this.state.loading ?
                            <div style={{marginTop: "150px"}}>
                                <CircularProgress size={50} thickness={5}/>
                            </div>
                            :
                            <div style={{paddingBottom: "80px"}}>
                                <Card className="location-edit-card">
                                    <div>
                                        <div className="centerHeader">
                                            <TextField
                                                name="name"
                                                errorText={this.state.errors.name}
                                                errorStyle={{
                                                    padding: "0 32px 0 32px",
                                                    fontStyle: "italic"
                                                }}
                                                hintText={"Infusion Center Name"}
                                                fullWidth={true}
                                                onChange={this.onChange.bind(null, "name", null)}
                                                value={this.state.edits['name'] ? this.state.edits['name'] + "" : ""}
                                                underlineStyle={{
                                                    borderWidth: "1px",
                                                    borderColor: "#dddddd"
                                                }}
                                                inputStyle={{
                                                    padding: "0 32px 0 32px",
                                                    color: "#18496c"
                                                }}
                                                style={{
                                                    padding: "10px 0 20px 0",
                                                    fontFamily: "Lato",
                                                    fontSize: "24px"
                                                }}
                                                hintStyle={{
                                                    padding: "0 32px 20px 32px"
                                                }}/>
                                        </div>
                                        <div className="location-edit-card-inside">
                                            <div className="location-edit-section-header">
                                                Location Information
                                            </div>
                                            {this.buildTextField("description", "Description", helpText.description, true)}
                                            {this.buildTextField("address1", "Address 1", "", false)}
                                            {this.buildTextField("address2", "Address 2", "", false)}
                                            <div style={{
                                                display: "flex"
                                            }}>
                                                <div style={{
                                                    flex: 1
                                                }}>
                                                    {this.buildTextField("city", "City", "", false)}
                                                </div>
                                                <div
                                                    style={{
                                                        padding: "0 32px 0 32px",
                                                        textAlign: "left"
                                                    }}>
                                                    {this.buildStateSelect()}
                                                </div>
                                                <div>
                                                    {this.buildTextField("postCode", "Zip", "", false)}
                                                </div>
                                            </div>
                                            <div style={{
                                                display: "flex"
                                            }}>
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        paddingRight: "16px"
                                                    }}>
                                                    {this.buildTextField("phoneNumber", "Phone", "", false)}
                                                </div>
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        paddingLeft: "16px"
                                                    }}>
                                                    {this.buildTextField("faxNumber", "Fax", "", false)}
                                                </div>
                                            </div>
                                            {this.buildTextField("emailAddress", "Email", helpText.email, false)}
                                            {this.buildTextField("url", "Website", "", false)}

                                            {this.props.user.isAdmin ?
                                                <div>
                                                    <div className="location-edit-section-header" style={{marginBottom: "20px"}}>
                                                        Google Street View Override
                                                    </div>
                                                    <GoogleStreetViewUpload
                                                        onImageUploaded={this.onGoogleStreetViewImageUploaded}
                                                        onDeleteClick={this.onGoogleStreetViewDeleteClick}
                                                        edits={this.state.edits} />
                                                </div>
                                                :
                                                null
                                            }

                                            {this.props.user.isAdmin || this.props.user.isPreferred ?
                                                <div>
                                                    <div className="location-edit-section-header" style={{marginBottom: "20px"}}>
                                                        Images
                                                    </div>
                                                    <ImageUpload
                                                        onImageUploaded={this.onImageUploaded}
                                                        onDeleteClick={this.onDeleteClick}
                                                        edits={this.state.edits}
                                                        onImageSortEnd={this.onImageSortEnd} />
                                                </div>
                                                :
                                                null
                                            }

                                            {this.state.attributeComponents}

                                            <div className="location-edit-section-header">
                                                Hours of Operation
                                            </div>
                                            <BusinessHours
                                                location={this.state.edits}
                                                onUpdateBusinessHours={this.onUpdateBusinessHours} />
                                            <div style={{borderTop: "1px solid #dddddd"}}></div>

                                            <div className="location-edit-section-header">
                                                Languages Spoken
                                            </div>
                                            <div>
                                                {this.buildTextField("languagesSpoken", "Languages Spoken", "", false)}
                                            </div>

                                            <div className="location-edit-section-header">
                                                How Many Infusion Chairs Do You Have At This Location?
                                            </div>
                                            {this.buildTextField("numberOfChairs", "# Chairs", "", true, (value) => {return !value || value.match(/^[0-9]+$/)})}

                                            <div className="location-edit-section-header">
                                                Social Media URLs
                                            </div>
                                            {this.buildTextField("facebookPageId", "Facebook ID", helpText.fbHelp1, true)}
                                            {this.buildTextField("twitterHandle", "Twitter Handle", "@example", true)}

                                            <div className="location-edit-section-header">
                                                Temporarily Closed
                                            </div>
                                            <div style={{marginTop: "30px"}}>
                                                <Checkbox
                                                    label={"This location is temporarily closed"}
                                                    labelStyle={{color: "#1c5c7f", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                                                    uncheckedIcon={<img src={checkOffIcon} alt="check off" />}
                                                    onCheck={this.toggleTemporarilyClosed}
                                                    checked={this.state.edits['temporarily_closed']}/>
                                            </div>
                                            {this.buildTextField("temporarily_closed_reason", "Closed Reason", helpText.closed, true)}

                                            <div
                                                style={{
                                                    padding: "20px 0 20px 0",
                                                    textAlign: "right"
                                                }}>
                                                <FlatButton
                                                    label="Save"
                                                    labelStyle={{
                                                        color: "#ffffff"
                                                    }}
                                                    backgroundColor="#53c9e8"
                                                    onClick={this.onSaveClick}/>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        }
                    </div>
                </div>
                <Dialog
                    title="Unsaved Photos"
                    actions={[
                        <FlatButton label="cancel" onClick={this.closeDialog} />,
                        <FlatButton label="leave anyway" onClick={this.cleanupPhotos} />
                    ]}
                    modal={false}
                    open={this.state.showDialog}
                    onRequestClose={this.closeDialog}
                >
                    If you leave you will lose your unsaved Photos. Are you sure you want to proceed?
                </Dialog>
                <div className={"location-edit-validator-banner " + (this.state.showErrorBanner ? "location-edit-validator-banner-show" : "")}>
                    <div className="location-edit-validator-banner-inside-container">
                        <div style={{flex: 1}}>
                            <div className="location-edit-validator-banner-title">
                                Not so fast, we need a little more info from you.
                            </div>
                            <div className="location-edit-validator-banner-subtitle">
                                We’ve highlighted the missing info in red italic text
                            </div>
                        </div>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <FlatButton
                                label="Got It"
                                labelStyle={{color: "white"}}
                                onClick={this.hideErrorBanner}
                                style={{height: "46px", border: "solid 2px #ffffff", borderRadius: "4px"}} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class BusinessHours extends Component {
    isRowChecked(index) {
        return this.props.location.businessHours != null &&
            this.props.location.businessHours[this.getOpenKey(index)] != null;
    }

    getOpenKey(index) {
        return daysOfTheWeek[index].toLowerCase() + "Open";
    }

    getCloseKey(index) {
        return daysOfTheWeek[index].toLowerCase() + "Close";
    }

    getOpenDate(index) {
        return this.getDateForTime(this.props.location.businessHours[this.getOpenKey(index)]);
    }

    getCloseDate(index) {
        return this.getDateForTime(this.props.location.businessHours[this.getCloseKey(index)]);
    }

    getDateForTime(time) {
        let date = new Date()
        let timeParts = time.split(":");
        let hr = timeParts[0];
        let min = timeParts[1];
        date.setHours(hr);
        date.setMinutes(min);
        return date;
    }

    onRowCheck = (index, event, checked) => {
        let businessHours = this.props.location.businessHours || {};

        if (checked) {
            businessHours[this.getOpenKey(index)] = "9:0";
            businessHours[this.getCloseKey(index)] = "17:0";
        } else {
            delete businessHours[this.getOpenKey(index)];
            delete businessHours[this.getCloseKey(index)];
        }

        this.props.onUpdateBusinessHours(businessHours);
    }

    handleTimeChange = (key, event, date) => {
        // console.log("time change");
        // console.log(key);
        // console.log(event);
        // console.log(date);

        let businessHours = {...this.props.location.businessHours};
        businessHours[key] = date.getHours() + ":" + date.getMinutes();

        // console.log("setting " + date.getHours() + ":" + date.getMinutes() + " for " + key);

        this.props.onUpdateBusinessHours(businessHours);
    }

    render() {
        return (
            <div className="location-edit-business-hours-container">
                {daysOfTheWeek.map((day, index) => {
                    return (
                        <div className="location-edit-business-hours-row" key={"bizhrs-" + index}>
                            <div style={{display: "flex", flex: 1}}>
                                <Checkbox
                                    label={day}
                                    checked={this.isRowChecked(index)}
                                    labelStyle={{color: "#1c5c7f", fontFamily: "Lato", fontSize: "18px", fontWeight: 200}}
                                    uncheckedIcon={<img src={checkOffIcon} alt="check off" />}
                                    onCheck={this.onRowCheck.bind(null, index)} />
                            </div>
                            {this.isRowChecked(index) ?
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div>
                                        <TimePicker
                                            name={"location-edit-business-hours-" + day + "-open"}
                                            className="location-edit-time-picker"
                                            textFieldStyle={{width: "100px", cursor: "pointer", fontFamily: "Lato", fontSize: "16px", color: "red"}}
                                            style={{color: "#1c5c7f !important"}}
                                            format="ampm"
                                            autoOk={true}
                                            value={this.getOpenDate(index)}
                                            onChange={this.handleTimeChange.bind(null, this.getOpenKey(index))} />
                                    </div>
                                    <div className="location-edit-business-hours-from">
                                        to
                                    </div>
                                    <div>
                                        <TimePicker
                                            name={"location-edit-business-hours-" + day + "-close"}
                                            textFieldStyle={{width: "100px", cursor: "pointer", fontFamily: "Lato", fontSize: "16px", color: "#1c5c7f"}}
                                            format="ampm"
                                            autoOk={true}
                                            value={this.getCloseDate(index)}
                                            onChange={this.handleTimeChange.bind(null, this.getCloseKey(index))} />
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    )
                })}
            </div>
        )
    }
}

const SortableItem = SortableElement(({index, value, onDeleteClick}) => {
    return (
        <div style={{position: "relative", zIndex: 4000}}>
            <div style={{position: "absolute", top: "0px", right: "10px"}}>
                <IconButton tooltip="Remove" onClick={onDeleteClick.bind(null, value, index)}>
                    <img src={remove_btn} alt="remove button" />
                </IconButton>
            </div>
            <img className="location-edit-image-preview" src={value} alt="location edit preview" />
        </div>
    );
});

const SortableList = SortableContainer(({items, onDeleteClick}) => {
    if (items) {
        return (
            <div style={{display: "flex"}}>
                {items.map((value, index) => (
                    <SortableItem key={'item-' + index} index={index} value={value} onDeleteClick={onDeleteClick} />
                ))}
            </div>
        );
    }
    return (<div></div>);
});

class ImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            showDialog: false
        }
    }

    onFileChanged = (event) => {
        // Tracker.trackEvent(CATEGORY, "file_chosen", "", 0);
        this.onFileDrop(event.target.files[0]);
    }

    onFileDrop = (file) => {
        // console.log(file);
        this.setState({uploading: true});
        api.uploadFile(file, this.guid(), (downloadURL) => {
            this.setState({uploading: false});
            this.props.onImageUploaded(downloadURL);
        });
    }

    onChooseFileClick = () => {
        this.refs.imageInput.click();
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    render() {
        return (
            <div>
                <DropZone
                    emptyContent={
                        <div>
                            <div className="drop-zone-title">Drag and Drop</div>
                            <div className="drop-zone-or">or</div>
                            <div>
                                <RaisedButton
                                    label="Choose File"
                                    buttonStyle={{width: "330px"}}
                                    primary={true}
                                    onTouchTap={this.onChooseFileClick} />
                            </div>
                            <input
                                ref="imageInput"
                                type="file"
                                id="image-file"
                                name="image-file"
                                accept=".jpg,.jpeg,.png,.gif"
                                style={{visibility: "hidden"}}
                                onChange={this.onFileChanged} />
                        </div>
                    }
                    accepts="jpg,jpeg,png,gif"
                    onDrop={this.onFileDrop}
                    uploading={this.state.uploading}
                />
                <SortableList items={this.props.edits.photos} axis="x" onDeleteClick={this.props.onDeleteClick} onSortEnd={this.props.onImageSortEnd}/>
                <div className="location-edit-help-text" style={{marginTop: "10px"}}>
                    Drag and drop the items in this list to re-arrange the photos. First photo is the primary image.
                </div>
            </div>
        )
    }
}

class GoogleStreetViewUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            showDialog: false
        }
    }

    onFileChanged = (event) => {
        // Tracker.trackEvent(CATEGORY, "file_chosen", "", 0);
        this.onFileDrop(event.target.files[0]);
    }

    onFileDrop = (file) => {
        // console.log(file);
        this.setState({uploading: true});
        api.uploadFile(file, this.guid(), (downloadURL) => {
            this.setState({uploading: false});
            this.props.onImageUploaded(downloadURL);
        });
    }

    onChooseFileClick = () => {
        this.refs.imageInput.click();
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    onSortEnd = () => {

    }

    render() {
        return (
            <div>
                {!this.props.edits.google_street_view_image ?
                    <DropZone
                        emptyContent={
                            <div>
                                <div className="drop-zone-title">Drag and Drop</div>
                                <div className="drop-zone-or">or</div>
                                <div>
                                    <RaisedButton
                                        label="Choose File"
                                        buttonStyle={{width: "330px"}}
                                        primary={true}
                                        onTouchTap={this.onChooseFileClick}/>
                                </div>
                                <input
                                    ref="imageInput"
                                    type="file"
                                    id="image-file"
                                    name="image-file"
                                    accept=".jpg,.jpeg,.png,.gif"
                                    style={{visibility: "hidden"}}
                                    onChange={this.onFileChanged}/>
                            </div>
                        }
                        accepts="jpg,jpeg,png,gif"
                        onDrop={this.onFileDrop}
                        uploading={this.state.uploading}
                    />
                    :
                    <SortableList items={[this.props.edits.google_street_view_image]} axis="x" onDeleteClick={this.props.onDeleteClick} onSortEnd={this.onSortEnd} />
                }
            </div>
        )
    }
}

export default AdminLocationDetails;



// WEBPACK FOOTER //
// ./src/components/admin-location-manager/AdminLocationDetails.js